import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'currency-symbol',
  templateUrl: './currency-symbol.component.html',
  styleUrls: ['./currency-symbol.component.scss'],
  standalone: false,
})
export class CurrencySymbolComponent implements OnInit {
  dir: string;
  @Input() type: string;
  constructor() {
    this.dir = localStorage.getItem('html-dir');
  }

  ngOnInit(): void {}

  isSymbol() {
    const _type = this.type || environment.countrySettings.currency;
    return _type == 'SAR';
  }
}
